module.exports = __webpack_public_path__ + "static/ruinsus-2d8685bf8919c1423e3235ad8602deee.png";